// extracted by mini-css-extract-plugin
export default {"reset":"RequirementInstructionsView_reset__PGbm-"};